import React from "react";
import { FooterSection } from "./FooterElements";

const Footer = () => {
  return (
    <FooterSection>Victor Nestor © {new Date().getFullYear()}</FooterSection>
  );
};

export default Footer;
